export const SessionLocalStorageKey = "app-session";
